/**
 * Genetec stream choice in the auto-add table (ENG-2043).
 *
 * actuate_admin's nvr_camera rows carry `genetec_stream_options`: probed
 * `[label, value]` pairs, value "" = Auto (the smallest stream the camera
 * offers). Rows without a probe (other integrations) carry null, so the Stream
 * column only appears when at least one row has options.
 */
export type GenetecStreamOption = [string, string];

export const genetecStreamOptions = (row: any): GenetecStreamOption[] =>
  Array.isArray(row?.genetec_stream_options) ? row.genetec_stream_options : [];

export const hasGenetecStreamOptions = (rows: any[] | undefined): boolean =>
  Array.isArray(rows) &&
  rows.some((row) => genetecStreamOptions(row).length > 0);

/** Current choice for a row; "" (Auto) until the user picks one. */
export const genetecStreamValue = (camerasObject: any, rowId: number): string =>
  camerasObject?.[rowId]?.genetec_stream ?? "";

/** Store the choice on the row's own entry so handleCreateAutoAddObject
 * sends it as the item's `genetec_stream`. A new object keeps the memoized
 * row's change check working. */
export const handleGenetecStreamInput = (
  setCamerasObject: any,
  value: string,
  rowId: number
) => {
  setCamerasObject((previousState: any) => ({
    ...previousState,
    [rowId]: { ...previousState[rowId], genetec_stream: value },
  }));
};
